module.exports = "<nv-react-component component=\"ManageTeamGroup\"></nv-react-component>";